import { FunctionComponent } from 'react';
import 'office-ui-fabric-core/dist/css/fabric.min.css'
import { msGridColClass } from './styles';

type ColSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export interface IBwjColProps {
  small: ColSize;
  medium?: ColSize;
  large?: ColSize;
  xLarge?: ColSize;
}

export const Col: FunctionComponent<IBwjColProps> = (props) => {
    const cls = [msGridColClass];

    let sm = !props.small || props.small < 1 ? 12 : props.small;
    addClass('sm', sm);
    addClass('md', props.medium);
    addClass('lg', props.large);
    addClass('xl', props.xLarge);

  return (
    <div className={cls.join(' ')}>
        {props.children}
    </div>
  );

  function addClass(name:string, value?: number) {
      if(!value || value < 0) { return; }

      let v = Math.floor(value);
      v = v > 12 ? 12 : v;
      cls.push(`ms-${name}${v}`);
  }
};